"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Color {
    constructor(r, g, b, a) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    static Black() {
        return new Color(0.0, 0.0, 0.0, 1.0);
    }
    static White() {
        return new Color(1.0, 1.0, 1.0, 1.0);
    }
    static Red() {
        return new Color(1.0, 0.0, 0.0, 1.0);
    }
    static Green() {
        return new Color(0.0, 1.0, 0.0, 1.0);
    }
    static Blue() {
        return new Color(0.0, 0.0, 1.0, 1.0);
    }
}
exports.Color = Color;
